import moment from 'moment'

const startDate = moment().minutes(0)
const endDate = moment().minutes(30)

export default {
  events: [],
  emptyEvent: {
    'isAllDay': false,
    'isTripWithPersonalVehicle': false,
    'type': 'default',
    'isValidated': null,
    'mileageAllowanceCost': 0,
    'startDate': startDate.format('YYYY-MM-DD HH:mm'),
    'startPlace': {},
    'endDate': endDate.format('YYYY-MM-DD HH:mm'),
    'endPlace': {},
    'documents': [],
    'steps': []
  },
  params: {
    entity: [
      // 'startPlace',
      // 'endPlace',
      'phase',
      'workflow',
      'documents',
      'additionalMembers',
      'workFlo'
    ],
    collection: [
      'place',
      'startPlace',
      'endPlace',
      'steps'
    ]
  }
}